import * as React from 'react';
import classnames from 'classnames';

import ModalFrameHeader from '../modal-frame-header/ModalFrameHeader';
import StepCounter from 'components/progress/step-counter/StepCounter';

import { expandDataProps } from 'utils/helper/common';

import type { Data } from 'types';

type Props = {
  children: React.ReactNode,
  title?: string | null,
  subtitle?: string | null,
  data?: Data,
  classNameFrame?: string,
  stepCounter?: {
    index: number,
    count: number
  }
};

class ModalFrame extends React.PureComponent<Props> {
  render() {
    const { title, subtitle, children, data, stepCounter, classNameFrame } = this.props;

    const frameClasses = classnames('modal-frame', classNameFrame);

    return (
      <section
        className={frameClasses}
        {...expandDataProps(data)}
      >
        {
          stepCounter &&
            <div className="modal-frame__step-counter">
              <StepCounter
                stepIndex={stepCounter.index}
                stepCount={stepCounter.count}
              />
            </div>
        }
        {
          (title || subtitle) &&
            <ModalFrameHeader
              title={title}
              subtitle={subtitle}
            />
        }
        {children}
      </section>
    );
  }
}

export default ModalFrame;
